import { CommentCallbackArgs, CommentConfig } from "component/comment";
import { ModeratedComment } from "feature/moderation/ai-premoderator";
import { getEnabledFeatures } from "util/features";
import { Feature } from "util/stdtypes";
export const AutoApproveFeature: Feature<CommentConfig, {}> = {
    name: 'Log all comments in Mod Dashboard',
    key: 'autoapprovecomments',
    dev: true,
    config: {
        commentPostTriggers: [createAutoApprovedModTask],
    }
}

async function createAutoApprovedModTask({ datastore, commentKey, comment }: CommentCallbackArgs & {comment: ModeratedComment}) {
    const enabledFeatures = getEnabledFeatures(datastore);
    if (!enabledFeatures['human_premoderation'] || comment.text.length===0) {
        await datastore.callServerAsync('moderationZdf', 'autoApprove', {
            type: 'comment', 
            key: commentKey
        });
    }
}